import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const useRiskAssessment = (portfolioUuid) => {
  const middleman = useMiddleman();
  return useQuery(['riskAssessment', portfolioUuid], () => {
    return middleman.promiseGet(`/risk-assessment/${portfolioUuid}`).then(response => response.data);
  }, {
    enabled: !!portfolioUuid,
  });
};

export const useRisksHistory = (portfolioUuid, shouldRun) => {
  const middleman = useMiddleman();
  return useQuery(['risksHistory', portfolioUuid], () => {
    return middleman.promiseGet(`/ql/crm/risk-assessment/risk/history/${portfolioUuid}`).then(response => response.data);
  } , {
    enabled: shouldRun,
  });
};